<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1">
    <ziro-breadcrumbs></ziro-breadcrumbs>

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    <div [hidden]="isLoading">
      <div class="card border-warning mb-3">
        <div class="card-body">
          <table>
            <tr>
              <td rowspan="2">
                <i class="fa fa-warning text-warning fa-2x"></i>
              </td>
              <td>
                <span>
                  {{ warningTextPreamble | translate }}
                </span>

                <br />

                <span class="strong text-warning">
                  {{ warningText | translate }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
        <div [hidden]="importFileType === importFileTypes.CDR">
          <div class="row">
            <div class="col-sm-12">
              <ziro-radio [fieldId]="'importFrom'"></ziro-radio>
            </div>
          </div>

          <hr />
        </div>

        <div class="row">
          <div class="col-sm-offset-2 col-sm-10">
            <ziro-text [fieldId]="'contextUrl'"></ziro-text>
            <ziro-text [fieldId]="'username'"></ziro-text>
            <ziro-text [fieldId]="'password'"></ziro-text>
            <ziro-file-upload [fieldId]="'importFromFile'"></ziro-file-upload>
          </div>
        </div>
      </ziro-collapsible-section-card>
    </div>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
